module.exports = __webpack_public_path__ + "static/content_bg-bbc1dc62b96ad86993de2916be4c3189.svg";